var trivialArgsMapper = function trivialArgsMapper(payload, meta) {
  return {
    payload: payload,
    meta: meta
  };
};

export default trivialArgsMapper;